!(function(t,e,a,r,n,s,d,l,o,i,u){(t.Adjust=t.Adjust||{}),(t.Adjust_q=t.Adjust_q||[]);for(var c=0;c<l.length;c++)o(t.Adjust,t.Adjust_q,l[c]);(i=e.createElement(a)),(u=e.getElementsByTagName(a)[0]),(i.async=!0),(i.src="https://cdn.adjust.com/adjust-latest.min.js"),(i.onload=function(){for(var e=0;e<t.Adjust_q.length;e++)t.Adjust[t.Adjust_q[e][0]].apply(t.Adjust,t.Adjust_q[e][1]);t.Adjust_q=[]}),u.parentNode.insertBefore(i,u)})(window,document,"script",0,0,0,0,["initSdk","getAttribution","getWebUUID","setReferrer","trackEvent","addGlobalCallbackParameters","addGlobalPartnerParameters","removeGlobalCallbackParameter","removeGlobalPartnerParameter","clearGlobalCallbackParameters","clearGlobalPartnerParameters","switchToOfflineMode","switchBackToOnlineMode","stop","restart","gdprForgetMe","disableThirdPartySharing","initSmartBanner","showSmartBanner","hideSmartBanner",],function(t,e,a){t[a]=function(){e.push([a,arguments])}},);

import { ADJUST_CONFIG_PC, ADJUST_CONFIG_H5 } from "@/constant/adjust-event";
import { DEVICE_TYPE } from "@/constant";


let isValid = false;
let adjustConfig = {};
const gameID = window.location.pathname.split('/').pop();

export function initAdjustReport() {
  const isMobile = DEVICE_TYPE.isMobile;
  // 判断如果当前游戏没有配置adjust，return
  if (!(isMobile ? ADJUST_CONFIG_H5[gameID] : ADJUST_CONFIG_PC[gameID])) {
    return;
  }
  if (isMobile ? ADJUST_CONFIG_H5[gameID].app_token : ADJUST_CONFIG_PC[gameID].app_token) {
    const appToken = isMobile ? ADJUST_CONFIG_H5[gameID].app_token : ADJUST_CONFIG_PC[gameID].app_token;
    adjustConfig = isMobile ? ADJUST_CONFIG_H5[gameID] : ADJUST_CONFIG_PC[gameID];
    /**
     * initSdk: initiate adjust sdk instance, do it only once per page load
     */
    Adjust.initSdk({
      appToken: appToken, // required
      environment: "production", // required, 'production' or 'sandbox' in case you are testing SDK locally with your web app
      attributionCallback: function (e, attribution) {
        // optional
        // define your attribution callback function
      },
      logLevel: "none", // optional, default is 'error', other options are 'none', 'error', 'warning', 'info', 'verbose'
      logOutput: "#output", // optional, outputs logs from sdk into provided container
      // defaultTracker: 'YOUR_DEFAULT_TRACKER_TOKEN', // optional
      // externalDeviceId: 'YOUR_EXTERNAL_DEVICE_ID', // optional
      // customUrl: 'YOUR_CUSTOM_URL', // optional
      // eventDeduplicationListLimit: 'YOUR_EVENT_DEDUPLICATION_LIST_LIMIT' // optional, default set to 10
      // namespace: 'YOUR_CUSTOM_STORAGE_NAMESPACE' // optional, namespace for sdk data storage
    });
    isValid = true;
    setTimeout(() => {
      const uuid = Adjust.getWebUUID();
      console.log("adjust-uuid", uuid);
      localStorage.setItem("adjust_uuid", uuid);
    }, 2000);
  }
}

initAdjustReport();

export function reportEvent(evt) {
  if (!isValid) {
    return;
  }
  if (adjustConfig != {} && adjustConfig.event_token[evt]) {
    console.log("adjust evt---", evt);
    const openid = localStorage.getItem("cg_openid") ?? "";
    Adjust.trackEvent({
      eventToken: adjustConfig.event_token[evt],
      callbackParams: [
        { key: "openid", value: openid },
     ],
    });
  }
}

const AdjustSDK = {
  initAdjustReport,
  reportEvent
}

export default AdjustSDK;